import { useCallback, useEffect, useState } from 'react'

import Big from 'big.js'
import { CLAIM, MODULE_ADDRESS } from 'config'

import { useCommonConnectStore } from 'components/WalletProvider/store.ts'

import useIsUserListed from './useIsUserListed.ts'

const fn = `${MODULE_ADDRESS}::claim::get_user_stats`

type UserStats = [vested_balance: string, balance: string, claimed: string]

const useGetUserClaim = (address: string) => {
  const [isClaimStatusLoading, setIsClaimStatusLoading] = useState(false)
  const [userClaim, setUserClaim] = useState('0')
  const [vestedBalance, setVestedBalance] = useState('0')
  const [receivedClaim, setReceivedClaim] = useState('0')
  const [claimStatus, setClaimStatus] = useState(CLAIM.UNAVAILABLE)

  const { isLoading: isUserListLoading, isUserListed } = useIsUserListed(address)
  const client = useCommonConnectStore((state) => state.client)
  const fetchBalance = useCallback(() => {
    setIsClaimStatusLoading(true)
    client
      .view({ arguments: [address], function: fn, type_arguments: [] })
      .then((data: UserStats) => {
        setVestedBalance(data[0])
        setUserClaim(data[1])
        setReceivedClaim(data[2])
        console.log('User stats:', { balance: data[1], claimed: data[2], vested: data[0] })
      })
      .catch((error) => {
        console.error('Failed to fetch balance:', error)
      })
      .finally(() => {
        setIsClaimStatusLoading(false)
      })
  }, [address, client])

  useEffect(() => {
    if (client) {
      fetchBalance()
    }
  }, [client, fetchBalance])

  const updateClaimStatus = ({
    balance,
    claimed,
    isListed,
    vested,
  }: {
    balance: number | string
    claimed: number | string
    isListed: boolean
    vested: number | string
  }) => {
    const _vestedBalance = new Big(vested) // 1
    const _balance = new Big(balance) // 2
    const _claimed = new Big(claimed) // 3

    if (!isListed) {
      setClaimStatus(CLAIM.NOT_LISTED)
    } else if (_claimed.gte(_vestedBalance)) {
      setClaimStatus(CLAIM.ALL_CLAIMED)
    } else if (_balance.eq(0)) {
      setClaimStatus(CLAIM.ALL_IN_ROUND_CLAIMED)
    } else if (_balance.gt(0)) {
      setClaimStatus(CLAIM.AVAILABLE)
    } else {
      setClaimStatus(CLAIM.UNAVAILABLE)
    }
  }

  useEffect(() => {
    updateClaimStatus({ balance: userClaim, claimed: receivedClaim, isListed: isUserListed, vested: vestedBalance })
  }, [userClaim, vestedBalance, receivedClaim, isUserListed])

  return {
    claimStatus,
    fetchBalance,
    isClaimStatusLoading,
    isUserListLoading,
    receivedClaim,
    userClaim,
    vestedBalance,
  }
}
export default useGetUserClaim
